module.exports = __webpack_public_path__ + "static/media/NestedFolder.a2a17b75.svg";